/* ==========================================================================
   lockin — búsqueda predictiva y filtros de colección.
   Depende de window.theme (assets/theme.js).
   ========================================================================== */
(function () {
  'use strict';

  var theme = window.theme;
  if (!theme) return;

  var $ = theme.$;
  var $$ = theme.$$;
  var config = theme.config;

  /* Búsqueda predictiva
     Pide la sección predictive-search a /search/suggest mientras se escribe.
     Estados: indicación inicial, cargando (esqueleto), resultados, vacío y error.
     ------------------------------------------------------------------------ */
  function initPredictiveSearch() {
    var dialog = $('[data-predictive-search]');
    if (!dialog) return;

    var input = $('[data-predictive-input]', dialog);
    var results = $('[data-predictive-results]', dialog);
    var initial = results.innerHTML;
    var controller = null;
    var timer = null;

    var skeleton =
      '<div class="skeleton-stack" style="padding:0.5rem">' +
      '<div class="skeleton skeleton--row"></div><div class="skeleton skeleton--row"></div><div class="skeleton skeleton--row"></div></div>';

    function message(text) {
      results.innerHTML = '';
      var hint = document.createElement('p');
      hint.className = 'search-box__hint';
      hint.textContent = text;
      results.appendChild(hint);
    }

    function search(term) {
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;

      results.setAttribute('aria-busy', 'true');
      results.innerHTML = skeleton;

      var url =
        dialog.dataset.url +
        '?q=' +
        encodeURIComponent(term) +
        '&resources[type]=product,collection,page&resources[limit]=6&section_id=predictive-search';

      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var fresh = $('[data-predictive-content]', theme.parseHTML(html));
          results.innerHTML = fresh ? fresh.innerHTML : initial;
          input.setAttribute('aria-expanded', fresh ? 'true' : 'false');
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          message(config.strings.loadError);
        })
        .then(function () {
          results.removeAttribute('aria-busy');
        });
    }

    input.addEventListener('input', function () {
      var term = input.value.trim();
      window.clearTimeout(timer);
      if (term.length < 2) {
        if (controller) controller.abort();
        results.innerHTML = initial;
        input.setAttribute('aria-expanded', 'false');
        return;
      }
      timer = window.setTimeout(function () {
        search(term);
      }, 250);
    });

    /* Flechas: del campo a los resultados y entre resultados */
    dialog.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      var links = $$('a', results);
      if (!links.length) return;
      var index = links.indexOf(document.activeElement);
      event.preventDefault();
      if (event.key === 'ArrowDown') {
        links[index < links.length - 1 ? index + 1 : 0].focus();
      } else if (index <= 0) {
        input.focus();
      } else {
        links[index - 1].focus();
      }
    });

    dialog.addEventListener('close', function () {
      input.value = '';
      results.innerHTML = initial;
      input.setAttribute('aria-expanded', 'false');
    });
  }

  /* Filtros y ordenación de colección
     Envía el formulario al cambiar una opción y sustituye los resultados sin recargar.
     Sin JavaScript, el formulario funciona con su botón «Aplicar».
     ------------------------------------------------------------------------ */
  function initFacets() {
    var form = $('[data-facets]');
    var section = $('[data-collection-section]');
    if (!form || !section) return;

    function update(url, push) {
      var results = $('[data-collection-results]', section);
      if (results) results.setAttribute('aria-busy', 'true');

      fetch(url)
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var fresh = $('[data-collection-section]', theme.parseHTML(html));
          if (!fresh) throw new Error('sin contenido');
          var openFacets = $$('[data-facet][open]', section).map(function (facet) {
            return $$('[data-facet]', section).indexOf(facet);
          });
          section.innerHTML = fresh.innerHTML;
          openFacets.forEach(function (index) {
            var facet = $$('[data-facet]', section)[index];
            if (facet) facet.open = true;
          });
          if (push) window.history.pushState({}, '', url);
          theme.announceContent(section);
        })
        .catch(function () {
          if (results) results.removeAttribute('aria-busy');
          theme.toast({ title: config.strings.loadError, variant: 'error' });
        });
    }

    function formUrl() {
      var current = $('[data-facets]', section);
      var params = new URLSearchParams();
      new FormData(current).forEach(function (value, key) {
        if (value !== '') params.append(key, value);
      });
      var query = params.toString();
      return current.getAttribute('action') + (query ? '?' + query : '');
    }

    section.addEventListener('change', function (event) {
      if (event.target.closest('[data-facets]')) update(formUrl(), true);
    });

    section.addEventListener('submit', function (event) {
      if (!event.target.closest('[data-facets]')) return;
      event.preventDefault();
      update(formUrl(), true);
    });

    section.addEventListener('click', function (event) {
      var link = event.target.closest('[data-facet-link], .pagination a');
      if (!link) return;
      event.preventDefault();
      update(link.href, true);
      section.scrollIntoView({ block: 'start' });
    });

    /* Los desplegables de filtros se cierran con Esc o al hacer clic fuera */
    document.addEventListener('click', function (event) {
      $$('[data-facet][open]', section).forEach(function (facet) {
        if (!facet.contains(event.target)) facet.open = false;
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      $$('[data-facet][open]', section).forEach(function (facet) {
        facet.open = false;
        $('summary', facet).focus();
      });
    });

    window.addEventListener('popstate', function () {
      update(window.location.href, false);
    });
  }

  initPredictiveSearch();
  initFacets();
})();
